import { AutogenModelDriverManagerProfile, AutogenRowDriverManagerProfile } from "./autogen/AutogenModelDriverManagerProfile";

export class ModelDriverManagerProfile extends AutogenModelDriverManagerProfile<RowDriverManagerProfile> {
	constructor() {
		super(RowDriverManagerProfile);
	}
}

export class RowDriverManagerProfile extends AutogenRowDriverManagerProfile {
}
